module.exports = __webpack_public_path__ + "static/InterFace-343b7582cf3ab2ca2b3b6641462e27e6.woff";